import { Component, OnInit, OnDestroy } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';

import { AddNewJobFunctionDialogComponent } from '../add-new-job-function-dialog/add-new-job-function-dialog.component';
import { EditJobFunctionDialogComponent } from '../edit-job-function-dialog/edit-job-function-dialog.component';

import { AdminService, AlertService, CommonService } from '../../../_services/';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-job-function-list',
  templateUrl: './job-function-list.component.html',
  styleUrls: ['./job-function-list.component.scss']
})
export class JobFunctionListComponent implements OnInit {
  jobFunctions:any;
  private subscription: Subscription;
  constructor(
    public dialog: MatDialog,
    private _common : CommonService,
    private _admin : AdminService,
    private _alert : AlertService
  ) { }

  ngOnInit() {
    this.getJobFunctionList()
  }
  openAddNewJobFunctionDialog(){
    let dialogRef = this.dialog.open(AddNewJobFunctionDialogComponent, {
      width: 'auto',
    });

    dialogRef.afterClosed().subscribe(response => {
    })

  }

  getJobFunctionList(){
    this._common.showLoader(true);

    this.subscription = this._admin.getJobFunctionList().subscribe(result=>{
      this._common.showLoader(false);
      this.jobFunctions = result;
    },err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })

  }
  
  // delete job function...
  deletejobFunction(id){
    this._common.showLoader(true);
    this._admin.deleteJobFunction(id).then((res)=>{
      this._common.showLoader(false);
      this._alert.success('Job Function deleted successfully!');
    }).catch(err=>{
      this._common.showLoader(false);
      this._alert.error(err.error.message?err.error.message:'Something went wrong!');
    })
  }
  // edit job function dialog
  openJobFunctionDialog(id){
    let dialogRef = this.dialog.open(EditJobFunctionDialogComponent, {
      width: 'auto',
      data:{
        id:id
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      // this.getUserList(localStorage.getItem('uid'))
    })

  }

  ngOnDestroy(){
    if(this.subscription) this.subscription.unsubscribe();
  }



}

